module.exports = __webpack_public_path__ + "img/Kreis_her.c34d932b.png";